export function runScheduleWorker(input, signal) {
  return new Promise((resolve, reject) => {
    if (signal?.aborted) {
      resolve(null)
      return
    }
    const worker = new Worker(new URL('./scheduleLeague.worker.js', import.meta.url))
    let timer
    const finish = (error, result = null) => {
      clearTimeout(timer)
      signal?.removeEventListener('abort', cancel)
      worker.terminate()
      if (error) reject(error)
      else resolve(result)
    }
    const cancel = () => finish(null)
    signal?.addEventListener('abort', cancel, { once: true })
    timer = setTimeout(() => finish(new Error('Scheduling took too long. Try Start again, or review the team divisions and season weeks.')), 30000)
    worker.onmessage = ({ data }) => finish(data.error ? new Error(data.error) : null, data.result)
    worker.onerror = () => finish(new Error('The league scheduler could not run. Reload the page and try again.'))
    worker.onmessageerror = () => finish(new Error('The league scheduler returned an unreadable result. Please try again.'))
    try {
      worker.postMessage(input)
    } catch (error) {
      finish(error)
    }
  })
}
